/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Button from "../ui/Button";
import Text from "../ui/Text";
import { useTranslate } from "../../hooks/useTranslate";
import { useNavigate } from "react-router-dom";
import { useFormatters } from "../../hooks/useFormatters";
import { formatDateTime } from "../../utils/helpers/formatters";
import { ROUTES } from "../../constants/constants";
import Divider from "../ui/Divider";
import Stack from "../ui/Stack";

const WaitingListActionBlock = styled(Stack)`
  width: 100%;
  max-width: 300px;
`;

const WaitingListAction = ({ selectedDate, withDivider }) => {
  const { _t } = useTranslate();
  const navigate = useNavigate();
  const { FormatDateTime } = useFormatters();

  return (
    <WaitingListActionBlock $gap="1.5rem" $align="center">
      {withDivider && <Divider label="or" style={{ width: "100%" }} />}
      <Stack $gap="1rem" $align="center">
        <Button
          variant="secondary"
          title="Join the waiting list"
          onClick={() => navigate(ROUTES.WAITING_LIST_DETAILS)}
        />
        <Text size="small">{_t("Want this exact day? We'll email you if a slot opens on %date%.", {
          date: FormatDateTime({ value: selectedDate, format: formatDateTime.FORMAT.DATE }),
        })}</Text>
      </Stack>
    </WaitingListActionBlock>
  );
};

export default WaitingListAction;
